import React, { Component } from "react";
import logo from "../../logo.png";
import SideNav from "./Side_Nav";

class Admin_Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.name
    };
  }

  render() {
    return (
      <header
        className={
          this.props.loggedIn ? "Admin-header" : "Admin-header signed-out"
        }
      >
        <div className="admin-inner-header">
          <img src={logo} className="Admin-logo" alt="logo" />
          <h1 className="Admin-title">
            {this.props.loggedIn
              ? `Welcome back ${this.props.name}`
              : "Admin Panel"}
          </h1>
        </div>

        {this.props.loggedIn ? <SideNav logout={this.props.logout} /> : null}
      </header>
    );
  }
}

export default Admin_Header;



// WEBPACK FOOTER //
// ./src/admin/includes/Admin_Header.js